import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { AssistanceRejectedIcon, Button } from '@frontend/components';

import { SUGGESTION_ANNOTATION_COMMAND_TYPES } from 'modules/common/viewer/pdfViewer/annotationCommands';
import { suggestionAnnotations } from 'modules/common/viewer/pdfViewer/data/actions';

type MarkInaccurateActionProps = {
  printExtractionUuid?: string | null;
  onClose: () => void;
  /**
   * Optional override for the mark-as-inaccurate handler.
   * When provided, this is called instead of dispatching a viewer event.
   * Useful for contexts outside the viewer (e.g., reqsReview findings)
   * that need direct mutation + query invalidation.
   */
  onMarkInaccurate?: () => void;
};

export const MarkInaccurateAction = ({
  printExtractionUuid,
  onClose,
  onMarkInaccurate,
}: MarkInaccurateActionProps) => {
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    if (!printExtractionUuid) return;
    if (onMarkInaccurate) {
      onMarkInaccurate();
    } else {
      dispatch(
        suggestionAnnotations.queueCommands({
          commands: [
            {
              type: SUGGESTION_ANNOTATION_COMMAND_TYPES.DELETE_PRINT_EXTRACTION,
              payload: { printExtractionUuid },
            },
          ],
        }),
      );
    }
    onClose();
  }, [printExtractionUuid, dispatch, onClose, onMarkInaccurate]);

  return (
    <Button
      colorScheme="destructive"
      variant="link"
      size="sm"
      icon={<AssistanceRejectedIcon />}
      onClick={handleClick}
    >
      Mark as inaccurate
    </Button>
  );
};
